export const baseUrl = process.env.REACT_APP_BASE_URL;

// urls
export const loginPost = "api/users/login";
export const signUpPost = "api/users";
export const verifyToken = "api/verifyToken";
export const getMovies= "api/users/movieList";
export const googleSignup = "api/users/googleSignup"; 
export const searchMovie = "api/users/searchMovie";
export const otplogin = "api/users/otplogin";
export const loginOtp = "api/users/sendOtp";
export const getAllPoster = "api/users/getAllPoster"; 
export const profileEditPost = "api/users/editprofile";
export const getMovie = "api/users/getMovie"; 
export const addReview = "api/users/reviews";
export const getAllReview = "api/users/getAllReview";
export const deleteReview = "api/users/deleteReview";
export const getAllTheater= "api/users/getAllTheater";
export const getAllCitys = "api/users/getAllCity";
export const getgenre= "api/admin/getgenre";
export const categorymovie = "api/users/categorymovie";
export const getScreenShows = "api/users/getScreenShows";
export const seatReserved = "api/users/seatReserved";
export const getQrcodes = "api/users/getQrcode"; 
export const reservation = "api/users/reservation";  
export const addWishlist= "api/users/addWishlist";
export const removeWishlist= "api/users/removeWishlist";
export const cancelTicket = "api/users/cancelTicket";
export const BookingHitory = "api/users/history";